import clsx from 'clsx'
import React from 'react'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

import { translateTravelType } from './travel-type.utils'
import SelectableButton from '../../selectable-button/SelectableButton'
import { TravelTypeEnum } from '../../../../../../lib/graphql'
import { Tooltip, TooltipProps } from '../../../../../atoms'
import { TravelTypeIcon } from '../../../../../forms/travel-type-picker/travel-type-icon/TravelTypeIcon'

interface TravelTypeButtonProps {
  travelType: TravelTypeEnum
  isDisabled: boolean
  isSelected: boolean
  onClick: () => void
  tooltipProps: Pick<TooltipProps, 'content' | 'disable' | 'position'>
}

const TravelTypeButton: React.FC<TravelTypeButtonProps> = ({
  travelType,
  isDisabled,
  isSelected,
  onClick,
  tooltipProps,
}) => {
  const intl = useIntl()

  return (
    <Tooltip {...tooltipProps} contentClassName={s.tooltip}>
      <SelectableButton
        isDisabled={isDisabled}
        onClick={onClick}
        isSelected={isSelected}
        content={
          <>
            <TravelTypeIcon
              travelType={travelType}
              style={{
                height: 20,
                width: 20,
                color: isSelected
                  ? 'var(--clr-black)'
                  : 'var(--clr-text-subtle)',
              }}
            />
            <span className={clsx(s.label, { [s.labelSelected]: isSelected })}>
              {intl.formatMessage(translateTravelType(travelType))}
            </span>
          </>
        }
      />
    </Tooltip>
  )
}

export default TravelTypeButton
